<template>
  <form
    class="form-horizontal kv-form-horizontal">

    <small>
      {{ $t('message.uplatnuje') }}
    </small>
    <hr>

    <div class="row">
      <div class="col-md-9">
        <b-form-checkbox
          v-model="items.uplatnuje_p6ods1a2"
          value="1"
          unchecked-value="0"
          plain>
          {{ $t('message.u_p6ods1a2') }}</b-form-checkbox>
      </div>
    </div>

    <div class="row">
      <div class="col-md-9">
        <b-form-checkbox
          v-model="items.uplatnuje_p6ods4"
          value="1"
          unchecked-value="0"
          plain>
          {{ $t('message.u_p6ods4') }}</b-form-checkbox>
      </div>
    </div>

    <small>
      Ukončujem uplatňovanie osobitného spôsobu zahrnovania kurzových
      rozdielov do základu dane podľa § 17 ods. 17 zákona
    </small>
    <hr>

    <div class="row">
      <div class="col-md-9">
        <b-form-checkbox
          v-model="items.ukoncuje_p6ods1a2"
          value="1"
          unchecked-value="0"
          plain>
          {{ $t('message.u_p6ods1a2') }}</b-form-checkbox>
      </div>
    </div>

    <div class="row">
      <div class="col-md-9">
        <b-form-checkbox
          v-model="items.ukoncuje_p6ods4"
          value="1"
          unchecked-value="0"
          plain>
          {{ $t('message.u_p6ods4') }}</b-form-checkbox>
      </div>
    </div>

    <b-button
      class="btn-primary"
      @click="save">{{ $t('message.lblSave') }}</b-button>

  </form>
</template>

<script>
import restEditor from '@/mixins/restEditor';

export default {

  mixins: [restEditor],
  data() {
    return {
      id: null,
      parent: this.$route.params.userId,
      items: {
        id: null,
        parent: null,
        uplatnuje_p6ods1a2: null,
        uplatnuje_p6ods4: null,
        ukoncuje_p6ods1a2: null,
        ukoncuje_p6ods4: null,
      },
    };
  },
  validations: {
    items: {
      uplatnuje_p6ods1a2: {},
      uplatnuje_p6ods4: {},
      ukoncuje_p6ods1a2: {},
      ukoncuje_p6ods4: {},
    },
  },

  methods: {
    async processGet() {
      this.id = await this.restDataSource.getSposobId(this.parent, 6);
      if (this.id !== null) {
        this.items = await this.restDataSource.getData(this.id, 'par6sposobkr');
      }
    },
    async processSave() {
      if (this.id === null) {
        this.items.parent = this.parent;
        this.items.id = this.id;
        await this.restDataSource.createData(this.items, 'par6sposobkr');
      } else {
        await this.restDataSource.updateData(this.items, 'par6sposobkr');
      }
    },
  },

};
</script>

<style>
.form-row > .col, .form-row > [class*="col-"] {
    padding-right: 30px;
    padding-left: 0px;
}
.form-check-label {
    margin-bottom: 12px;
}
.form-check-inline .form-check-input {
    margin-top: -12px;
}
small {
  font-size:1.2em;
  color: #333;
}
</style>
